define('responsive-gameday-scoreboard/responsive-gameday-scoreboard',['require','./src/js/GamedayScoreboard'],function(require) {
    return require('./src/js/GamedayScoreboard');
});
